import { typography, FONT_FAMILY } from 'styles/typography'

const themeStyles = colors => {
  const styles = {
    container: isMobile => {
      return isMobile
        ? { margin: '15px 0' }
        : {
            display: 'flex',
            flexDirection: 'row',
            flexWSrap: 'wrap',
            justifyContent: 'flex-start',
            padding: 30,
            border: 0,
            paddingLeft: 0,
            paddingRight: 0
          }
    },
    itemBox: isOnSelect => {
      return {
        ...typography.fontBold,
        border: '1px solid',
        borderRadius: '3px',
        marginRight: 15,
        height: 100,
        minWidth: 100,
        padding: '20px',
        textAlign: 'center',
        cursor: 'pointer',
        position: 'relative',
        userSelect: 'none',
        color: isOnSelect ? colors.white : colors.approxBlack,
        pointerEvents: isOnSelect && 'none',
        backgroundColor: isOnSelect && colors.primary,
        borderColor: isOnSelect ? colors.primary : colors.webBorder
      }
    },
    imgBox: isOnSelect => {
      return {
        fill: isOnSelect ? colors.white : colors.iconGrey
      }
    },
    link: isOnSelect => {
      return {
        color: isOnSelect ? colors.white : colors.approxBlack
      }
    },
    img: () => {
      return {
        height: 34,
        width: 34
      }
    },
    item: () => {
      return {
        width: 'fit-context',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        whiteSpace: 'nowrap'
      }
    },
    dropdown: {
      fontFamily: FONT_FAMILY,
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: 14,
      lineHeight: '20px',
      border: `1px solid ${colors.silverGray}`,
      padding: '1rem',
      backgroundColor: colors.white,
      color: colors.approxBlack,
      borderRadius: 4
    },
    icon: {
      position: 'relative'
    },
    menu: {
      width: '100%'
    },
    menuItem: {
      width: '100%',
      color: colors.approxBlack
    },
    activeMenuItem: {
      backgroundColor: colors.lighterSmoke,
      fontWeight: 700
    }
  }
  return styles
}

export default themeStyles

